import React from "react";
import HomeSlider from "../component/HomeSlider";
import CategorySlider from "../component/CategorySlider";
import { useEffect, useState } from "react";
import img1 from "../component/img/img1.jpg";
import img2 from "../component/img/img2.jpg";
import img7 from "../component/img/img7.jpg";

import ProductCards from "../component/ProductCards";
import VisitorNavbar from "../component/VisitorNavbar";
import Footer from "../component/Footer";
import CommonSetOne from "../component/CommonSetOne";

import { baseurl, imageUrl } from "../Baseurl";
import axios from "axios";
import FeaturedProduct from "../component/FeaturedProduct";
import BlogSection from "../component/BlogSection";
import Testimonial from "../component/Testimonial";
import BestSellingProduct from "../component/BestSellingProduct";

const Home = () => {
  const [fullbanner, setFullbanner] = useState([]);
  const [halfbanner, setHalfbanner] = useState([]);
  const [maincategories, setCategories] = useState([]);
  const [listings, setListings] = useState([]);

  useEffect(() => {
    // Fetch the data from the HomePageData API
    const fetchData = async () => {
      try {
        const response = await axios.get(`${baseurl}HomePageData`);

        // Store the fetched data in the respective state variables
        const { fullbanner, halfbanner, maincategories, listings } =
          response.data;

        setFullbanner(fullbanner);
        setHalfbanner(halfbanner);
        setCategories(maincategories);
        setListings(listings);
      } catch (error) {
        console.error("Error fetching data:", error.message);
      }
    };

    fetchData();
  }, []);

  const [row1, setRow1] = useState(null);
  const [row2, setRow2] = useState(null);
  const [row3, setRow3] = useState(null);

  useEffect(() => {
    // Fetch data from getAllOtherHalf API
    const fetchBanners = async () => {
      try {
        const response = await axios.get(`${baseurl}getAllOtherHalf`);

        // Extract the banners data
        const { data } = response.data;

        // Ensure at least 3 rows are available
        if (data.length >= 3) {
          setRow1(data[0]); // First banner
          setRow2(data[1]); // Second banner
          setRow3(data[2]); // Third banner
        }
      } catch (error) {
        console.error("Error fetching banners:", error.message);
      }
    };

    fetchBanners();
  }, []);

  const halfbannerItems = Array.isArray(halfbanner) ? halfbanner : [];
  // console.log("Fullbanner Data:", fullbanner);

  return (
    <>
      <VisitorNavbar />

      <div className=" ">
        <HomeSlider fullbanner={fullbanner} />

        <section className="py-2" style={{ backgroundColor: "#0a2264" }}>
          <h1 className="txt1 text-white text-center">Shop by Category</h1>
          
          <div>
            <CategorySlider maincategories={maincategories} />
          </div>
        </section>

       
      </div>


      <BestSellingProduct listings={listings}/>

      <ProductCards listings={listings} />

      <section className=" py-2 px-2 fwd-section">
        <div className="container-fluid">
          <h1 className="txt1">Featured Product</h1>
          <div>
            <FeaturedProduct listings={listings} />
          </div>
        </div>
      </section>

      <Testimonial />

      <BlogSection />

      <Footer />
    </>
  );
};

export default Home;
